<template>
  <div>
    <v-card style="margin-left:1px; margin-right:1px;">
      <v-card-title class="text-h6 blue darken-1 lighten-2 py-2">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="h6" style="color:white!important;">
              <v-icon color="white">mdi-format-list-bulleted-type</v-icon>
              Preguntas
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        
        <v-row class="mx-2 mt-2">
          <v-col v-if="loadingComp" class="text-center" cols="12">
            <v-skeleton-loader type="image" />
          </v-col>
          <v-col v-else class="text-center" cols="12">
            <v-alert 
              v-if="lstPreguntas.length == 0"
              type="info">
              Aún no se registra ninguna respuesta en la encuesta
            </v-alert>

            <v-expansion-panels
              v-model="panel"
              multiple
              inset
            >
              <v-expansion-panel
                v-for="(item,i) in lstPreguntas"
                :key="i"
              >
                <v-expansion-panel-header v-slot="{ open }">
                  <v-row no-gutters>
                    <v-col :cols="open ? 10 : 8" style="margin: auto 0">
                      <v-avatar
                        class="mr-2"
                        color="teal"
                        size="25px"
                        dark
                        style="color:white"
                      >
                        {{i+1}}
                      </v-avatar>
                      <strong v-html="item.nombrePregunta"></strong>
                    </v-col>
                    <v-col
                      v-if="!open"
                      cols="2"
                      class="text--secondary text-center"
                    >
                      <v-fade-transition leave-absolute>
                        <v-row
                          no-gutters
                          style="width: 100%"
                        >
                          <v-col cols="12">
                            <v-icon>{{item.idCatTipoPreguntaNavigation.icono}}</v-icon>
                            {{item.idCatTipoPreguntaNavigation.tipoPregunta}}
                          </v-col>
                        </v-row>
                      </v-fade-transition>
                    </v-col>
                    <v-col
                      cols="2"
                      class="text--secondary text-center"
                    >
                      <v-fade-transition leave-absolute>
                        <v-row
                          no-gutters
                          style="width: 100%"
                        >
                          <v-col cols="12">
                          </v-col>
                        </v-row>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                

                  <v-row>
                    <v-col cols="12" class="text-center">
                      <b>Tipo de pregunta</b><br><v-icon>{{item.idCatTipoPreguntaNavigation.icono}}</v-icon> {{item.idCatTipoPreguntaNavigation.tipoPregunta}}
                    </v-col>
                  </v-row>
                  
                  <!-- Tipo Numerico (2) -->
                  <v-row v-if="item.idCatTipoPregunta == 2">
                    <!--<v-col cols="12" md="3" class="text-center">
                      <b>Valor Mínimo</b><br>{{item.valorMinimo}}
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                      <b>Valor Máximo</b><br>{{item.valorMaximo}}
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                      <b>¿Promediable?</b><br><v-icon>{{item.promediable == true ? "mdi-check" : "mdi-close" }}</v-icon>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                      <b>¿Selector numérico?</b><br><v-icon>{{item.selectorNumerico == true ? "mdi-check" : "mdi-close" }}</v-icon>
                    </v-col>
                  -->
                  </v-row>

                  <v-row v-if="item.idCatTipoPregunta == 2 && item.selectorNumerico == true">
                    <!--
                    <v-col cols="12" md="6" class="text-center">
                      <b>Etiqueta Inicial</b><br>{{item.etiquetaInicial}}
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                      <b>Etiqueta Final</b><br>{{item.etiquetaFinal}}
                    </v-col>
                    -->
                  </v-row>


                  <!-- Tipo Respuestas múltiples (3, 4) -->
                  <v-row v-if="item.idCatTipoPregunta == 3 || item.idCatTipoPregunta == 4">
                    <!--<v-col cols="12" md="12" class="text-center">
                      <b>Respuestas ordenadas en horizontal</b><br><v-icon>{{item.horizantal == true ? "mdi-check" : "mdi-close" }}</v-icon>
                    </v-col>
                    -->
                  </v-row>

                  <!-- Tipo Parámetro (6) -->
                  <v-row v-if="item.idCatTipoPregunta == 6">
                    <!--<v-col cols="12" md="6" class="text-center">
                     
                      <b>Parámetro visible</b><br><v-icon>{{item.parametroVisible == true ? "mdi-check" : "mdi-close" }}</v-icon>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                      <b>Tipo de parámetro</b><br>{{item.idCatParametroNavigation.nombreParametro}}
                    </v-col>
                  --->
                  </v-row>

                  <!-- Pregunta y respuesta dependientes -->
                  <v-row v-if="item.idPreguntaDependiente != null && item.idPreguntaDependiente != undefined">
                    <!--
                    <v-col cols="12" :md="item.idCatRespuestaDependiente == null ? 12 : 6" class="text-center">
                      <b>Pregunta dependiente</b><br>{{item.idPreguntaDependienteNavigation.nombrePregunta}}
                    </v-col>
                    <v-col v-if="item.idCatRespuestaDependiente != null" cols="12" md="6" class="text-center">
                      <b>Respuesta dependiente</b><br>{{item.idCatRespuestaDependienteNavigation.respuesta}}
                    </v-col>
                    -->
                  </v-row>

                  <!-- Campos siempre activos -->
                  <!--
                  <v-row>
                    <v-col cols="12" md="6" class="text-center">
                      <b>Habilitada</b><br><v-icon>{{item.habilitado == true ? "mdi-check" : "mdi-close" }}</v-icon>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                      <b>Requerida</b><br><v-icon>{{item.requerida == true ? "mdi-check" : "mdi-close" }}</v-icon>
                    </v-col>
                  </v-row>
-->
<!--
                  <v-row v-if="item.idCatTipoPregunta == 3 || item.idCatTipoPregunta == 4">
                    <v-col cols="12">
                      <respuestas-preg-sec-enc 
                        :id-seccion="idSeccion"
                        :id-pregunta="item.idPregunta" 
                        :lst-respuestas="item.eiCatRespuesta"
                        :fn-set-respuestas-pregunta="fnSetRespuestas"
                      >
                      </respuestas-preg-sec-enc>
                    </v-col>
                  </v-row>
-->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import{ getPreguntasBySeccion } from "@/api";

export default {
  name: "IndicadoresPreguntasSeccionEncuesta",
  components: {
    DialogFormPregunta: () =>
      import("../disenarEncuesta/DialogFormPregunta"),
    DialogOrdenarPreguntas: () =>
      import("../disenarEncuesta/DialogOrdenarPreguntas"),
    DialogEliminarPregunta: () =>
      import("../disenarEncuesta/DialogEliminarPregunta"),
    RespuestasPregSecEnc: () =>
      import("../disenarEncuesta/RespuestasPregSecEnc"),
  },
  props: {
    idEncuesta: {
      type: Number,
      required: true,
    },
    idSeccion: {
      type: Number,
      required: true,
    },
    loadingProp: {
      type: Boolean,
      default: false
    },
    lstPreguntas: {
      type: Array,
      default: function () {
        return []
      }
    },
    fnSetPreguntas: {
      type: Function,
      default: () => {}
    },
    fnSetRespuestas: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      loadingPreguntas: false,
      panel: [],
    };
  },
  computed: {
    loadingComp: function () {
      return this.loadingProp || this.loadingPreguntas
    },
    lstGrupos: function () {
      return this.lstPreguntas.filter(n=>n.grupo != '' && n.grupo != null).map(n=>n.grupo).filter((x, i, a) => a.indexOf(x) == i)
    }
  },
  beforeMount () {},
  async mounted () {
  },
  methods: {
    /*async obtenerPreguntasBySeccion () {

      var self = this;
      self.loadingPreguntas = true;
      var _lstPreguntas = [];

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getPreguntasBySeccion(self.idSeccion);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              _lstPreguntas = response.data.data;
              self.fnSetPreguntas(this.idSeccion, _lstPreguntas);
            //  this.getListadoResultadoEncuestaIndicadores();

}
          } else {
            self.error = response.data.message;
            self.snackbarTexto = "PreguntasSeccionEncuesta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "PreguntasSeccionEncuesta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingPreguntas = false;
      } catch (e) {
        self.loadingPreguntas = false;
        self.error = e;
        self.snackbarTexto = "PreguntasSeccionEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },**/

  }
};
</script>



<style>
.v-stepper__label{
  display: contents!important;
}

.div_btn_inline{
  display:inline;
}
</style>